import './index.css';
import './App.css';

import AppRoutes from '@routes/Router';
import { BrowserRouter } from 'react-router-dom';
import { DialogProvider } from '@context/DialogContext.js';
import { GlobalStyles } from '@mui/material';
import { LoadingProvider } from '@context/LoadingContext.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material';
// import App from './App';
import reportWebVitals from './reportWebVitals';
import theme from '@components/Styles/theme.js';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <LoadingProvider>
          <DialogProvider>
            <AppRoutes />
          </DialogProvider>
        </LoadingProvider>
      </ThemeProvider>
    </BrowserRouter>
  </>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
